export const MODEL_ROUTE = '/pharmacies';
